import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute, Params }   from '@angular/router';
import { CustomerInfosService } from './customer-infos.service';
import { AuthenticationService } from '../security/authentication.service';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { User } from '../entity/user';
import { Order } from '../entity/order';
import {environment} from '../../environments/environment';
import {CommentsComponent} from '../comments/comments.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import {IMyOptions, IMyDateModel} from 'ngx-mydatepicker';
@Component({
  selector: 'customer-infos',
  templateUrl: './customer-infos.component.html'
})
export class CustomerInfosComponent {

  private status: string;
  private currentUser: User;
  private mode: string;
  private allOrders;
  private orders: Order[];
  public search: string;
  public counts: {};
  public lastComment: {};
  public allComments;
  private filters;
  public loadingMore: boolean;
  private currentPage: number;
  public loading: boolean;
  public modalRef: BsModalRef;

  constructor(private route: ActivatedRoute, private authenticationService: AuthenticationService, private customerInfosService: CustomerInfosService, private spinnerService: SpinnerService, private modalService: BsModalService) {
    this.currentUser = null;
    this.mode = "INFOS";
    this.orders = new Array();
    this.search = "";
    this.lastComment = {};
    this.allComments = new Array();
    this.loadingMore = false;
    this.loading = false;
    this.filters = {dateStart:null, dateEnd:null, request:null, sample:null, du:null, product:null, selectedStatus:""};

  }

    private datePickerOptions: IMyOptions = {
        // other options...
        dateFormat: 'dd/mm/yyyy',
        dayLabels: {su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam'},
        monthLabels: { 1: 'Janvier', 2: 'Fevrier', 3: 'Mars', 4: 'Avril', 5: 'Mai', 6: 'Juin', 7: 'Juillet', 8: 'Aout', 9: 'Septembre', 10: 'Octobre', 11: 'Novembre', 12: 'Decembre' },
        showTodayBtn: false,
        sunHighlight: false,
        alignSelectorRight: false
    };

  ngOnInit(): void {
    this.allOrders = this.route.snapshot.data['orders']['orders'];
    this.counts = this.route.snapshot.data['orders']['counts'];
    this.lastComment = this.route.snapshot.data['orders']['lastComment'];
    this.allComments = this.route.snapshot.data['orders']['allComments'];
    if(this.authenticationService.isAuthenticated()){
      this.currentUser = this.authenticationService.getCurrentUser();
    }
    this.setSelectedStatus('VALIDE');
  }

  public selectMode(mode): void {
    this.mode = mode;
  }

  /************************/
  /*****  Mode INFOS  *****/
  /************************/

  private editCustomerInfos(): void
  {
    this.authenticationService.editUserInfos(this.currentUser.thirdParty);
    this.spinnerService.start("Enregistrement des modifications");
    this.customerInfosService.editCustomerInfos(this.currentUser.thirdParty).then(
      function(code: any){
        this.spinnerService.stop();
      }.bind(this),
      function(){
        this.spinnerService.stop();
      }.bind(this)
    );
  }

  /***************************/
  /*****  Mode DEMANDES  *****/
  /***************************/

  public displayDemandesBtn(): boolean {
    let currentUserType = this.authenticationService.getCurrentUser().thirdParty.type;
    return environment.dairyRoles.indexOf(currentUserType.code) >= 0;
  }

  public setSelectedStatus(status: string){
    this.status = status;
    if(this.allOrders[status] != undefined) {
      this.orders = this.allOrders[status];
    } else {
      this.orders = new Array();
    }
  }

    filter(): void {
        this.spinnerService.start('Merci de patienter');
        this.loading = true;
        // get orders
        let criteria = {
            start_date: this.filters.dateStart,
            end_date: this.filters.dateEnd,
            request: this.filters.request,
            sample: this.filters.sample,
            selectedStatus: this.filters.selectedStatus,
            page: this.currentPage
        };
        this.customerInfosService.getCustomerInfosOrders(criteria).then(
            function(response: any){
                this.allOrders = response.orders;
                this.counts = response.counts;
                this.lastComment =  response.lastComment;
                this.allComments = response.allComments;
                this.spinnerService.stop();
                this.loading = false;
            }.bind(this),
            function(){
                this.spinnerService.stop();
            }.bind(this)
        );
    }

    clearFilters(): void {
        this.spinnerService.start('Merci de patienter');
        this.loading = true;
        this.filters = {dateStart:null, dateEnd:null, request:null, sample:null, du:null, product:null, selectedStatus:""};

        // get orders
        let criteria = {
            start_date: this.filters.dateStart,
            end_date: this.filters.dateEnd,
            request: this.filters.request,
            sample: this.filters.sample,
            selectedStatus: this.filters.selectedStatus,
            page: this.currentPage
        };
        this.customerInfosService.getCustomerInfosOrders(criteria).then(
            function(response: any){
                this.allOrders = response.orders;
                this.counts = response.counts;
                this.lastComment =  response.lastComment;
                this.allComments = response.allComments;
                this.spinnerService.stop();
                this.loading = false;
            }.bind(this),
            function(){
                this.spinnerService.stop();
            }.bind(this)
        );
    }

    openConfirmDialog(order) {

        this.modalRef = this.modalService.show(CommentsComponent,
            { class: 'modal-lg modal-dialog-centered',
                ignoreBackdropClick: true,
                keyboard: false
            });

        this.modalRef.content.order = order;

        this.modalRef.content.onClose.subscribe(result => {

            if(result) {
                /*let orderComments  = this.cancellationService.getOrderComments(order.number);
                console.log(orderComments);
                this.allComments[order.number] = [];
                this.allComments[order.number].push(orderComments);*/
                this.filter();
            }
        });
    }

    public cancelOrder(order){
        this.openConfirmDialog(order);
        // this.spinnerService.start('Merci de patienter');
        // prepare reject order data post request
        let data = new Object();
        data['orderNumber'] = order.number;

        this.modalRef.content.onClose.subscribe(result => {

            if(result) {
                // call api
                this.customerInfosService.postCancelOrder(data).then(
                    function(response: any){
                        this. filter();
                    }.bind(this),
                    function(){
                        this.spinnerService.stop();
                    }.bind(this)
                );
            }
        })

    }

}


// WEBPACK FOOTER //
// ./src/app/customer-infos/customer-infos.component.ts